export enum HazardTypes {
  Fire = "fire",
}
